import React, { useEffect, useRef, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate, useSearchParams } from "react-router-dom";
import usePageAll from "../../hooks/usePageAll";
import useJWT from "../../hooks/useJWT";
import useCart from "../../hooks/useCart";

const HeaderOne = () => {
  const phone = "+6587333600";

  const messageLinks = [
    {
      text: "Product Enquiry",
      msg: "Hi, I’m interested in your product. Can you provide more details on this product? I’d like to know about the price, specifications, and availability. Thanks!",
    },
    {
      text: "Related Order",
      msg: "Hello, I just placed an order with you. Can you please provide an update on the status or confirm when it will be shipped? Thanks!",
    },
    {
      text: "Related Payment",
      msg: "Hi, I recently made a payment for my order. I just wanted to confirm if the payment went through successfully. Can you check? Thanks!",
    },
    {
      text: "Shipping & Delivery",
      msg: "Hi, I’d like to inquire about the shipping status of my order. Can you provide the tracking details or let me know when it’s expected to arrive? Thanks!",
    },
    {
      text: "Return & Refund Order",
      msg: "Hello, I’d like to return or request a refund for my order. Could you guide me through the process? Thank you!",
    },
  ];

  const { user } = useJWT();
  const { fetchCart, data: cartData } = useCart();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (user && user.id) {
      fetchCart(user.id);
    }
  }, [user]);
  const keyword = searchParams.get("keyword");
  const [scroll, setScroll] = useState(false);
  const inputSearchRef = useRef(null);
  const mobileInputRef = useRef(null);
  const headerRef = useRef(null);
  const [searchTop, setSearchTop] = useState(0);
  const [activeSearchDesktop, setActiveSearchDesktop] = useState(false);
  const [activeSearchMobile, setActiveSearchMobile] = useState(false);
  const { fetchPage, data, status, error, resetStatus } = usePageAll();

  useEffect(() => {
    fetchPage();
    const onScroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (selectElement.data && selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  useEffect(() => {
    if (keyword !== "" && inputSearchRef.current) {
      inputSearchRef.current.value = keyword;
    }
  }, [keyword]);

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      if (inputSearchRef.current) {
        if (inputSearchRef.current.value !== "") {
          handleSearch(event);
        }
      }
    }
  };

  const handleSearchSubmit = (event) => {
    if (inputSearchRef.current) {
      if (inputSearchRef.current.value !== "") {
        //handleSearch(event);
        const searchValue = inputSearchRef.current.value;
        //console.log(searchValue);
        navigate("/search?keyword=" + encodeURIComponent(searchValue.trim()));
      }
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const searchValue = inputSearchRef.current.value;
    //console.log(searchValue);
    navigate("/search?keyword=" + searchValue);
    // Do something with the search value, such as navigate to a search page
  };
  // Set the default language
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Set the default currency
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
  };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
    setActiveSearchMobile(false);
  };

  // compute top offset for mobile sticky search (sum visible header parts)
  const computeSearchTop = () => {
    try {
      // find bottom-most visible header element and place search below it
      const candidates = Array.from(
        document.querySelectorAll(".header-middle, .header"),
      );
      let maxBottom = 0;
      candidates.forEach((el) => {
        if (!el) return;
        const style = window.getComputedStyle(el);
        if (style && style.display !== "none") {
          const rect = el.getBoundingClientRect();
          if (rect.bottom > maxBottom) maxBottom = rect.bottom;
        }
      });
      const gap = 12; // small gap under header (increased)
      setSearchTop(Math.ceil(maxBottom + gap));
    } catch (err) {
      setSearchTop(0);
    }
  };

  // Search control support (separate desktop/mobile toggles)
  const handleSearchToggle = (mode = "desktop") => {
    if (mode === "mobile") {
      if (activeSearchMobile) {
        setActiveSearchMobile(false);
      } else {
        computeSearchTop();
        setActiveSearchMobile(true);
        setTimeout(() => mobileInputRef.current?.focus(), 80);
      }
    } else {
      setActiveSearchDesktop((s) => !s);
    }
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  // compute the top offset for the mobile sticky search (below header)
  useEffect(() => {
    computeSearchTop();
    window.addEventListener("resize", computeSearchTop);
    window.addEventListener("orientationchange", computeSearchTop);
    return () => {
      window.removeEventListener("resize", computeSearchTop);
      window.removeEventListener("orientationchange", computeSearchTop);
    };
  }, [scroll]);

  // While mobile search is open, keep recalculating top on scroll (so it stays attached)
  useEffect(() => {
    if (!activeSearchMobile) return;
    let rafId = null;
    const onScrollWhileOpen = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        computeSearchTop();
      });
    };
    window.addEventListener("scroll", onScrollWhileOpen, { passive: true });
    // also update on touchmove & wheel (some devices)
    window.addEventListener("touchmove", onScrollWhileOpen, { passive: true });
    window.addEventListener("wheel", onScrollWhileOpen, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScrollWhileOpen);
      window.removeEventListener("touchmove", onScrollWhileOpen);
      window.removeEventListener("wheel", onScrollWhileOpen);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [activeSearchMobile]);

  const handleMobileEnterPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (
        mobileInputRef.current &&
        mobileInputRef.current.value.trim() !== ""
      ) {
        navigate(
          "/search?keyword=" +
            encodeURIComponent(mobileInputRef.current.value.trim()),
        );
        setActiveSearchMobile(false);
      }
    }
  };

  const handleSearchSubmitMobile = (event) => {
    event.preventDefault();
    if (mobileInputRef.current && mobileInputRef.current.value.trim() !== "") {
      navigate(
        "/search?keyword=" +
          encodeURIComponent(mobileInputRef.current.value.trim()),
      );
      setActiveSearchMobile(false);
    }
  };

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form
        action="#"
        className={`search-box ${activeSearchDesktop && "active"}`}
      >
        <button
          onClick={() => handleSearchToggle("desktop")}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="assets/images/logo/logo-pink-peony.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {/* Home Menu */}
              {Array.isArray(data) &&
                data.length > 0 &&
                // sort by index
                data
                  .sort((a, b) => a.index - b.index)
                  .map((item, index) => {
                    return (
                      <li
                        key={index}
                        onClick={() => handleMenuClick(index)}
                        className={`on-hover-item nav-menu__item ${
                          activeIndex === 0 ? "d-block" : ""
                        }`}
                      >
                        {/* if item.url is not have string "/" then add it */}
                        <Link
                          to={
                            item.url.startsWith("/") ? item.url : `/${item.url}`
                          }
                          className="nav-menu__link"
                        >
                          {item.pageName}
                        </Link>
                      </li>
                    );
                  })}

              {/* Shop Menu
              <li
                onClick={() => handleMenuClick(1)}
                className={`on-hover-item nav-menu__item ${activeIndex === 1 ? "d-block" : ""
                  }`}
              >
                <Link to='/products' className='nav-menu__link'>
                  Products
                </Link>
              </li>

              {/* Pages Menu */}
              {/* <li
                onClick={() => handleMenuClick(2)}
                className={`on-hover-item nav-menu__item ${activeIndex === 2 ? "d-block" : ""
                  }`}
              >
                <Link to='/contact' className='nav-menu__link'>
                  Contact Us
                </Link>
              </li> */}

              {/* Contact Us Menu */}
              {/* <li className='nav-menu__item'>
                <Link
                  to='/become-seller'
                  className='nav-menu__link'
                  onClick={() => handleMenuClick(3)}
                >
                  Become A Seller
                </Link>
              </li> */}
              {/* 
              <li className='nav-menu__item'>
                <Link
                  to='/free-delivery'
                  className='nav-menu__link'
                  onClick={() => handleMenuClick(4)}
                >
                  Free Delivery
                </Link>
              </li> */}

              <li className="nav-menu__item">
                <Link
                  to="/account"
                  className="nav-menu__link"
                  onClick={() => handleMenuClick(data.length + 2 ?? 0)}
                >
                  My Account
                </Link>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Header Start ========================= */}
      <header className="header-middle pt-0 bg-main-one-50 border-bottom border-gray-100">
        <div className="header-ribbon d-none d-lg-block">
          <div className="container container-md">
            <div className="d-flex justify-content-between">
              <div>
                <div className="d-flex justify-content-start align-items-center">
                  <div>
                    {/* <a href="/wholesale/products" className="link">
                      Wholesale Price
                    </a> */}
                    {/* <a href="/become-seller" className="link">
                                          Wholesale Price
                                        </a> */}
                  </div>
                  <div>
                    <a href="/free-delivery" className="link border-0">
                      Free Delivery
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <Link
                  to="/account"
                  className="nav-menu__link border-0"
                  onClick={() => handleMenuClick(data.length + 2 ?? 0)}
                >
                  <i className="ph ph-user-circle"></i>{" "}
                  {user?.firstName || user?.email || "My Account"}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container container-md">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className=""></div>
            {/* Logo End  */}
            {/* form location Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="/assets/images/logo/logo-pink-peony.png" alt="Logo" />
              </Link>
            </div>
            <div className="d-lg-none d-block"></div>
            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>

                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#waModal"
                  className="flex-align gap-4 item-hover bg-transparent border-0 p-0"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-chat-circle" />
                    {/* <span className="w-16 h-16 flex-center rounded-circle bg-main-one-600 text-white text-xs position-absolute top-n6 end-n4">
                      2
                    </span> */}
                  </span>
                </button>
                {/* <Link to="/wishlist" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-heart" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-one-600 text-white text-xs position-absolute top-n6 end-n4">
                      2
                    </span>
                  </span>
                </Link> */}
                <Link to="/cart" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    {cartData && cartData.length > 0 && (
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-one-600 text-white text-xs position-absolute top-n6 end-n4">
                        {cartData.length}
                      </span>
                    )}
                  </span>
                  {/* <span className='text-md text-gray-500 item-hover__text d-none d-lg-flex'>
                    Cart
                  </span> */}
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        ref={headerRef}
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      >
        <div className="container container-md py-10">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
              >
                {" "}
                <i className="ph ph-list" />{" "}
              </button>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                <ul className="nav-menu flex-align ">
                  {Array.isArray(data) &&
                    data.length > 0 &&
                    // sort by index
                    data
                      .sort((a, b) => a.index - b.index)
                      .map((item, index) => {
                        return (
                          <li
                            className="on-hover-item nav-menu__item"
                            key={index}
                          >
                            <NavLink
                              to={
                                item.url.startsWith("/")
                                  ? item.url
                                  : `/${item.url}`
                              }
                              reloadDocument
                              className={(navData) =>
                                navData.isActive
                                  ? "nav-menu__link activePage"
                                  : "nav-menu__link"
                              }
                            >
                              {item.pageName}
                            </NavLink>
                          </li>
                        );
                      })}
                  {/* <li className="on-hover-item nav-menu__item">
                    <NavLink
                      to="/"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Home
                    </NavLink>
                  </li> */}
                  {/* <li className='on-hover-item nav-menu__item'>
                    <NavLink to='/products' className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }>
                      Products
                    </NavLink>
                    
                  </li> */}
                  {/* <li className='nav-menu__item'>
                    <NavLink
                      to='/contact'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li> */}
                  {/* <li className='nav-menu__item'>
                    <NavLink
                      to='/become-seller'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Become A Seller
                    </NavLink>
                  </li> */}
                  {/* <li className='nav-menu__item'>
                    <NavLink
                      to='/free-delivery'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Free Delivery
                    </NavLink>
                  </li> */}
                  <li className="nav-menu__item">
                    <NavLink
                      to="/account"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      My Account
                    </NavLink>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className="header-right flex-align">
              <form
                action="#"
                className="flex-align flex-wrap form-location-wrapper"
              >
                <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                  <div className="search-form__wrapper position-relative">
                    <input
                      ref={inputSearchRef}
                      onKeyDown={handleEnterPress}
                      type="text"
                      className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                      placeholder="Search for a product or brand"
                    />
                    <button
                      type="button"
                      onClick={handleSearchSubmit}
                      className="w-32 h-32 bg-main-one-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                    >
                      <i className="ph ph-magnifying-glass" />
                    </button>
                  </div>
                </div>
              </form>
              <div className="d-lg-none d-block">
                <div className="flex-align flex-wrap gap-12">
                  {/* <button
                    onClick={handleSearchToggle}
                    type='button'
                    className='search-icon flex-align d-lg-none d-flex gap-4 item-hover'
                  >
                    <span className='text-2xl text-gray-700 d-flex position-relative item-hover__text'>
                      <i className='ph ph-magnifying-glass' />
                    </span>
                  </button> */}
                  {/* <Link to="/wishlist" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-one-600 text-white text-xs position-absolute top-n6 end-n4">
                        2
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link> */}
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSearchToggle("mobile");
                    }}
                    className="flex-align gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                      {/* <span className="w-16 h-16 flex-center rounded-circle bg-main-one-600 text-white text-xs position-absolute top-n6 end-n4">
                        2
                      </span> */}
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Search
                    </span>
                  </Link>
                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      {cartData && cartData.length > 0 && (
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-one-600 text-white text-xs position-absolute top-n6 end-n4">
                          {cartData.length}
                        </span>
                      )}
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
      <form
        action="#"
        className={`search-box search-box--mobile d-lg-none d-block ${activeSearchMobile && "active"}`}
        onSubmit={handleSearchSubmitMobile}
        style={{
          position: "fixed",
          top: `${searchTop}px`,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1100,
          width: "calc(100% - 80px)",
          maxWidth: "640px",
        }}
      >
        <button
          onClick={() => handleSearchToggle("mobile")}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              ref={mobileInputRef}
              onKeyDown={handleMobileEnterPress}
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-one-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>

      {/* Modal Pilihan */}
      <div
        className="modal fade"
        id="waModal"
        tabIndex={-1}
        aria-labelledby="waModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow">
            <div className="modal-header bg-main-one-900 text-white">
              <h5 className="modal-title text-white" id="waModalLabel">
                Select an Option
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-center">
              <div className="list-group">
                {messageLinks.map((item, i) => (
                  <Link
                    key={i}
                    to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(item.msg)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="list-group-item list-group-item-action"
                  >
                    {item.text}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderOne;
